import { browserHistory } from 'react-router';

export function addQuery(query) {
  const location = {
    ...browserHistory.getCurrentLocation(),
    query,
  };
  browserHistory.push(location);
}

export function removeQuery(...queryNames) {
  const location = { ...browserHistory.getCurrentLocation() };
  queryNames.forEach(q => delete location.query[q]);
  browserHistory.push(location);
}

export function urlToArray(urlString) {
  // Adapted from here https://github.com/intesso/url-breadcrumb/blob/master/index.js
  // Extract url path (without querystring and without hash)
  const urlPath = urlString.split(/[?#]/)[0];
  // Split segments by slash and filter empty elements
  const segments = urlPath.split(`/`).filter(Boolean);
  // add first element for `home` element
  segments.unshift(``);

  // Add to segments array
  return segments.map((segment, i, arr) => {
    // Join the segments array up to the actual element with slash
    let href = arr.slice(0, i + 1).join(`/`);
    let title = ``;
    if (i === 0) {
      title = `Home`;
      href = `/`;
    }
    return {
      title,
      href,
    };
  });
}



// WEBPACK FOOTER //
// ./library/app/utils/routerUtils.js